import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.UserActionsToolbar.SyncDropdownContent', {
    title: 'Synchronisation status',
    syncAllButtonText: 'Sync all',
    syncFinishedMessage: '"{companyName}" {templateName} pulled from {integrationName}.',
});
